import { render, staticRenderFns } from "./source.vue?vue&type=template&id=6c35b3c7&scoped=true"
import script from "./source.vue?vue&type=script&lang=js"
export * from "./source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c35b3c7",
  null
  
)

export default component.exports